import { CurrencyEnum, useCustomToasts } from '@systemeio/ui'
import { useState } from 'react'

export const useCurrency = ({ currencyChangeMessage }: { currencyChangeMessage: string }) => {
  const [currentCurrency, setCurrentCurrency] = useState<CurrencyEnum>()
  const [toastShown, setToastShown] = useState(false)
  const { infoToast } = useCustomToasts()

  const showToast = () => {
    if (toastShown) return
    infoToast(currencyChangeMessage)
    setToastShown(true)
  }

  return { currentCurrency, setCurrentCurrency, showToast }
}
